export default __webpack_public_path__ + "static/media/body-couple-daytime-821042.ce6c4f3e.jpg";